"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

const asGate = (details) => {
  const gate = details 
  if (!gate || typeof gate !== 'object') return null
  if (typeof gate.Ready !== 'boolean' || !Array.isArray(gate.MissingVariables)) return null
  return gate 
}

/* Returns the launch gate result carried by a rejected StartCampaign,
 * UpdateCampaign or AddPatientsToCampaign, or null for any other failure.
 * Accepts the CommandError thrown by wsCommand or the raw socket error. */
 const campaignGateFromError = (err) => {
  if (!err || typeof err !== 'object') return null
  const { extra, Details } = err 
  return _nullishCoalesce(asGate(_optionalChain([extra, 'optionalAccess', _ => _.Details])), () => ( asGate(Details)))
}; exports.campaignGateFromError = campaignGateFromError
